
import {
  mdiClose,
  mdiCellphone,
  mdiCheck,
  mdiChevronRight,
  mdiChevronLeft,
} from "@mdi/js";
import { getMessengerLink, isDateInRange } from "~/common/helpers";
import iconMessage from "~/components/icons/IconMessage.vue";
import IconCircle from "~/components/v2/icons/IconCircle.vue";
import IconActiveStep from "~/components/v2/icons/IconActiveStep.vue";
import IconStepDone from "~/components/v2/icons/IconStepDone.vue";
import { emailRegexp } from "~/common/regexp";
import { mapGetters } from "vuex";
import parsePhoneNumber from "libphonenumber-js/max";
import MessageForm from "~/components/v2/message/message-form.vue";
import { AsYouType } from "libphonenumber-js/max";
const asYouType = new AsYouType();

const weekDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export default {
  components: {
    iconMessage,
    IconCircle,
    IconActiveStep,
    IconStepDone,
    MessageForm,
  },

  props: {
    slug: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      mdiClose,
      mdiCellphone,
      mdiCheck,
      mdiChevronRight,
      mdiChevronLeft,

      eventSlug: null,

      isOpen: false,
      modalHeaderText: "Book me",
      tab: 1,
      step: 1,
      confirmCopy: false,
      showContactError: false,

      form: {
        language_id: null,
        price_id: [],
        service_id: [],
        message: "",

        date: null,
        city: null,
        district_id: [],

        name: "",
        email: "",
        emailConfirm: "",
        phone: "+",

        agrement: false,
        price_service_id: 1,
        outcall_description: "",
        how_to_contact: [], // mail | call | whatsapp
      },

      errorNumber: {
        status: false,
        value: "",
      },

      numberIsValid: false,

      message: "",
      onTour: false,

      loading: false,

      detailsRules: [
        (v) => {
          return (
            (!!v && this.form.price_service_id === this.outcallId) ||
            this.$t("validations.field-is-required")
          );
        },
        (v) =>
          v?.length <= 150 ||
          this.$t("validations.max-characters", { count: 150 }),
      ],
      textRules: [(v) => !!v || this.$t("validations.field-is-required")],
      emailRules: [
        (v) => !!v || this.$t("validations.email-is-required"),
        (v) =>
          !v ||
          emailRegexp.test(v) ||
          this.$t("validations.e-mail-must-be-valid"),
      ],
      confirmEmailRules: [
        (v) => !!v || this.$t("validations.email-is-required"),
        (v) =>
          v == this.form.email || this.$t("validations.email-is-not-match"),
      ],
      requiredRules: [(v) => !!v || this.$t("validations.accept-terms")],
    };
  },

  computed: {
    ...mapGetters({
      schedule: "profile-schedule/getSchedule",
      profile: "profiles/getProfile",
      filterList: "profiles/getFiltersList",
    }),

    price_services() {
      if (!this.filterList.price_services) return [];
      return (
        Object?.keys(this.filterList.price_services)?.map((key) => {
          return {
            id: key,
            title: this.filterList.price_services[key],
          };
        }) || []
      );
    },

    slugToUse() {
      return this.eventSlug || this.slug;
    },

    phone() {
      return this.profile?.myDetails?.at(0)?.phone || "";
    },

    formattedPhone() {
      const phone = parsePhoneNumber(this.phone);

      if (phone?.formatInternational()) {
        return phone.formatInternational();
      } else {
        return this.$t("not-have-phone");
      }
    },

    dialogProps() {
      const props = {
        attach: "#app",
      };

      if (
        this.$device.isMobile ||
        (typeof window !== "undefined" && window.innerWidth < 710)
      ) {
        props.fullscreen = true;
        props.scrollable = true;
        props.transition = "dialog-bottom-transition";
        props.contentClass = "book-me-modal__dialog";
      } else {
        props.maxWidth = "520";
        props.contentClass = "book-me-modal__dialog-pc";
      }

      return props;
    },

    languages() {
      return this.profile?.myDetails?.at(0)?.languages || [];
    },

    prices() {
      return this.profile?.serviceDetails?.at(0)?.companionshipRates || [];
    },

    incallId() {
      if (!this.filterList.price_services) return null;
      return Object.keys(this.filterList.price_services).find((key) => {
        return this.filterList.price_services[key] === "Incall";
      });
    },

    outcallId() {
      if (!this.filterList.price_services) return null;
      return Object.keys(this.filterList.price_services).find((key) => {
        return this.filterList.price_services[key] === "Outcall";
      });
    },

    onlineId() {
      if (!this.filterList.price_services) return null;
      return Object.keys(this.filterList.price_services).find((key) => {
        return this.filterList.price_services[key] === "Online";
      });
    },

    incallRates() {
      return (
        this.profile?.serviceDetails
          ?.at(0)
          ?.companionshipRates.filter(
            (rate) => rate.price_service_id === +this.incallId
          ) || []
      );
    },

    outcallRates() {
      return (
        this.profile?.serviceDetails
          ?.at(0)
          ?.companionshipRates.filter(
            (rate) => rate.price_service_id === +this.outcallId
          ) || []
      );
    },

    onlineRates() {
      return (
        this.profile?.serviceDetails
          ?.at(0)
          ?.companionshipRates.filter(
            (rate) => rate.price_service_id === +this.onlineId
          ) || []
      );
    },

    servicesWithDisabled() {
      const maxSelected = 3;
      const selectedCount = this.form.service_id
        ? this.form.service_id.length
        : 0;
      const reachedLimit = selectedCount >= maxSelected;

      return (
        this.profile?.services?.map((s) => {
          const isSelected =
            this.form.service_id && this.form.service_id.includes(s);
          return {
            title: s.title,
            value: s.id,
            disabled: reachedLimit && !isSelected,
          };
        }) || []
      );
    },

    cities() {
      return (
        this.profile?.location?.map((l) => {
          return {
            title: l.baseCity,
            value: l.baseCityId,
          };
        }) || []
      );
    },

    tours() {
      return this.profile?.serviceDetails?.at(0)?.tours || [];
    },

    toursCities() {
      return this.tours.map((t) => {
        return {
          title: t.city.title,
          value: t.city.id,
        };
      });
    },

    allCities() {
      return this.cities.concat(this.toursCities);
    },

    districts() {
      return (
        (this.onTour
          ? [
              {
                title: "All",
                id: -1,
              },
            ]
          : this.profile?.districts?.map((d) => {
              return {
                title: d.title,
                id: d.id,
              };
            })) || []
      );
    },

    availableWeekDays() {
      if (this.schedule) {
        const weekDaysMap = new Set();
        Object.keys(this.schedule).forEach((k) => {
          if (this.schedule[k]) {
            const dayKey = k.split("_")[0];
            if (weekDays.includes(dayKey)) {
              weekDaysMap.add(dayKey);
            }
          }
        });
        return Array.from(weekDaysMap);
      }
      return [];
    },

    timesByDay() {
      if (this.schedule) {
        const times = {};
        this.availableWeekDays.forEach((day) => {
          let from = this.schedule[`${day}_time_from`];
          let to = this.schedule[`${day}_time_to`];

          from = from ? from.slice(0, 5) : "00:00";
          to = to ? to.slice(0, 5) : "23:59";

          times[day] = [from, to];
        });
        return times;
      }
      return {};
    },

    messengers() {
      return this.profile?.myDetails?.at(0)?.messengers || [];
    },
  },

  watch: {
    "form.date": function (newVal) {
      const tourFound = this.tours.find((tour) =>
        isDateInRange(newVal, tour.date_from, tour.date_to)
      );
      if (tourFound) {
        this.form.city = tourFound.city.id;
        this.form.district_id = [-1];
        this.onTour = true;
      } else {
        this.form.city = this.cities?.at(0)?.value;

        setTimeout(() => {
          this.form.district_id = [this.districts?.at(0)?.id];
        }, 500);
        this.onTour = false;
      }
    },
  },

  mounted() {
    this.prepareProfile();
    this.form.price_service_id = this.incallId;
    if (this.profile.id) {
      this.$store.dispatch("profile-schedule/fetchSchedule", this.profile.id);
    }
  },

  methods: {
    getMessengerLink,

    async copyPhone(e, messenger) {
      const messengersForPrevent = ["Signal", "WeChat"];
      if (messengersForPrevent.includes(messenger)) {
        e.preventDefault();
        e.stopPropagation();

        await this.$copyText(this.phone, this.$refs.phoneContainer);
        this.$notify({
          type: "success",
          message: this.$t("phone-copied"),
        });
      }
    },

    async open(newSlug) {
      this.eventSlug = newSlug;
      this.resetTabs();

      await this.prepareProfile();
      await this.$store.dispatch(
        "profile-schedule/fetchSchedule",
        this.profile.id
      );
      this.prepareForm();
      this.isOpen = true;
    },

    prepareForm() {
      this.form.profile_id = this.profile.id;

      this.form.language_id = this.languages?.at(0)?.id;
      this.form.price_id.push(this.prices?.at(0)?.id);

      this.form.city = this.cities?.at(0)?.value;
      this.form.district_id.push(this.districts?.at(0)?.id);

      if (this.$auth.loggedIn) {
        this.form.name = this.$auth.user.name;
        this.form.email = this.$auth.user.email;
        this.form.emailConfirm = this.$auth.user.email;
      }
    },

    async prepareProfile() {
      if (this.slugToUse && this.profile?.slug != this.slugToUse) {
        return await this.$store.dispatch("profiles/retrieveCurrentProf", {
          slug: this.slugToUse,
        });
      }
    },

    close() {
      this.isOpen = false;
      this.resetForm();
    },

    checkFirstStep() {
      if (!this.form.message) {
        this.$refs.messageError.style.opacity = "1";
      } else {
        this.$refs.messageError.style.opacity = "0";
        this.nextBookmeStep();
      }
    },

    checkDate() {
      if (!this.form.date) {
        this.$refs.dateError.style.opacity = "1";
      } else {
        this.$refs.dateError.style.opacity = "0";
        this.nextBookmeStep();
      }
    },

    submitStep3() {
      if (
        this.form.price_service_id == this.outcallId &&
        !this.form.outcall_description
      ) {
        this.$refs.oucallDetails.focus();
        this.$refs.oucallDetails.blur();
        return;
      } else {
        this.nextBookmeStep();
      }
    },

    nextBookmeStep() {
      this.step++;
    },

    prevBookmeStep() {
      this.step--;
    },

    messageCkick() {
      if (!this.$auth.loggedIn) {
        this.close();
        this.redirectAuth();
      }
    },

    redirectAuth() {
      if (window.innerWidth < 1024) {
        this.$root.$emit("sign-in-drawer:open");
      } else {
        this.$router.push({ name: "auth-signin" });
      }
    },

    allowedDates(val) {
      const weekDayName = new Intl.DateTimeFormat("en-US", {
        weekday: "long",
      }).format(new Date(val));
      const weekDayNameLower = weekDayName.toLowerCase();

      return (
        val >= new Date().toISOString().substring(0, 10) &&
        this.availableWeekDays.includes(weekDayNameLower)
      );
    },

    validateContactMethod() {
      this.showContactError = this.form.how_to_contact.length === 0;
    },

    async submit() {
      this.handlerPhoneNumber(this.form.phone);
      this.validateContactMethod();
      if (
        !this.$refs.form?.validate() ||
        this.errorNumber.status ||
        this.showContactError
      )
        return;
      try {
        this.loading = true;
        const res = await this.$axios.post("/api/booking/store", this.form);
        if (res.status === 200) {
          this.$notify({
            type: "success",
            message: "Booking was successful",
          });
          this.close();
        }
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "error",
          message: "Something went wrong",
        });
      } finally {
        this.loading = false;
        this.showContactError = false;
      }
    },

    resetForm() {
      this.form = {
        language_id: null,
        price_id: [],
        message: "",

        date: null,
        city: null,
        district_id: [],

        name: "",
        email: "",
        emailConfirm: "",

        agrement: false,
      };
      this.$refs.form?.resetValidation();
    },

    resetTabs() {
      this.step = 1;
      this.tab = 1;
    },

    resetErrorPhone() {
      this.errorNumber.status = false;
      this.errorNumber.value = "";
    },

    setErrorPhone({ status, value }) {
      this.errorNumber.status = status;
      this.errorNumber.value = value;
    },

    async handlerPhoneNumber(value, validate = true) {
      if (value.charAt(0) !== "+") {
        value = "+" + value;
      }

      asYouType.reset();
      asYouType.input(value);

      this.form.phone = asYouType.formattedOutput;

      if (validate) {
        if (asYouType.isValid()) {
          this.resetErrorPhone();
          this.numberIsValid = true;
        } else {
          this.setErrorPhone({
            status: true,
            value: this.$t("validations.phone-number-must-be-valid"),
          });
          this.numberIsValid = false;
        }
      }
    },

    phoneKeydown(e) {
      const input = e.target;

      // Prevent deleting the plus sign
      if (
        input.value === "+" &&
        (e.key === "Delete" || e.key === "Backspace")
      ) {
        e.preventDefault();
        return;
      }

      // Allow only digits and control keys
      if (
        (e.keyCode >= 48 && e.keyCode <= 57) || // Digits 0-9
        (e.keyCode >= 96 && e.keyCode <= 105) || // Numpad digits 0-9
        e.keyCode === 8 || // Backspace
        e.keyCode === 46 || // Delete
        e.keyCode === 37 || // Arrow left
        e.keyCode === 39 || // Arrow right
        (e.keyCode === 65 && e.ctrlKey === true) || // Ctrl+A (Select All)
        (e.keyCode === 67 && e.ctrlKey === true) || // Ctrl+C (Copy)
        (e.keyCode === 86 && e.ctrlKey === true) || // Ctrl+V (Paste)
        (e.keyCode === 88 && e.ctrlKey === true) || // Ctrl+X (Cut)
        (input.selectionStart === 0 && e.key === "+")
      ) {
        return;
      } else {
        e.preventDefault();
        ``;
      }
    },

    addToContacts() {
      const name = `${this.profile.name}`;
      const vCardData = `BEGIN:VCARD
VERSION:4.0
FN:${name}
URL:${this.$config.baseUrlApp}/profile/${this.profile.slug}
TEL;TYPE=CELL:${this.phone}
END:VCARD`;
      const blob = new Blob([vCardData], { type: "text/vcard" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${name}.vcf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
  },
};
